/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PeerFeedbackEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('PEER_FEEDBACK_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class PeerFeedbackEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PeerFeedbackEnabledSettingParser.decode(input).map(res => new PeerFeedbackEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return PeerFeedbackEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PeerFeedbackEnabledSettingParser.encode(data);
    }
    static schema() {
        return PeerFeedbackEnabledSettingParser.schema();
    }
}
